import {
  HTTP_INTERCEPTORS,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import 'rxjs/add/operator/do';
import { NotificationService } from '../shared/notification.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { Injectable } from '@angular/core';
import { RequestUtils } from '../shared/utils/request';

export const _disabledNotification = 'DISABLED';

const servedErrors = [401, 403, 404];

@Injectable()
export class HttpErrors implements HttpInterceptor {
  constructor(
    private notificationService: NotificationService,
    private requestUtils: RequestUtils,
    private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).do(
      () => {},
      err => {
        if (err instanceof HttpErrorResponse && this.requestUtils.isOurDomain(req)) {
          if (servedErrors.includes(err.status)) {
            if (err.status === 401) {
              window.sessionStorage.clear();
              this.router.navigateByUrl('/logout');
            }

            if (req.headers.get('disabledNotification') !== _disabledNotification) {
              if (err.status === 403) {
                this.notificationService.open('FORBIDDEN', {}, { closable: true });
              }

              if (err.status === 404) {
                this.notificationService.open('NOT_FOUND');
              }
            }
          } else {
            if (req.headers.get('disabledNotification') !== _disabledNotification) {
              if (err.error instanceof Array) {
                this.notificationService.open(err.error[0]);
              } else {
                this.notificationService.open('ERROR_FETCHING');
              }
            }
          }
        }
      }
    );
  }
}

export const HttpErrorsInterceptor = {
  provide: HTTP_INTERCEPTORS,
  useClass: HttpErrors,
  multi: true
};

export const disabledNotification = { headers: { disabledNotification: _disabledNotification } };
